<template>
	<div class="api_access">
		<h1 class="doc_main_h1">
			API接入流程
		</h1>
		<p class="doc_main_p">
			SKEye是盛开互动依托十余年研发积淀推出的图像识别技术平台，致力于为智能产品、应用提供精准快速的“云+端”图像识别SDK。SKEyeSDK是一套基于SKEye人工智能开放平台的图像识别服务。
		</p>
		<h3 class="doc_main_h3">
			1.用户注册
		</h3>
		<p class="doc_main_p">
			首先，你需要注册成为SKEye开放平台的用户；如果你已拥有账号，请略过这一步。
		</p>
		<h3 class="doc_main_h3">
			2.完善开发者资料
		</h3>
		<p class="doc_main_p">
			账号激活成功后，需要你登记开发者资料信息；完善信息后，才可以创建应用哦！
		</p>
		<h3 class="doc_main_h3">
			3.创建应用 & 分配密钥
		</h3>
		<p class="doc_main_p">
			（1）应用创建成功后，系统将为你分配一对密钥（API Key和API Secret），密钥是你使用API和SDK的凭证；开放平台暂不支持密钥的更换，请你妥善保管。
		</p>
		<p class="doc_main_p">
			（2）目前最多只能创建10个应用。
		</p>
		<h3 class="doc_main_h3">
			4.签名的生成
		</h3>
		<p class="doc_main_p">
			开放平台通过签名来验证请求的合法性，用户可以使用API Key和API Secret生成签名，具体签名生成方法请参阅用户鉴权服务方案。
		</p>
		<h3 class="doc_main_h3">
			5.调用API，进行开发
		</h3>
		<p class="doc_main_p">
			目前暂以API的的形式提供服务，后续会提供离线SDK。API的具体使用方法，请参阅API文档。
		</p>
	</div>
</template>
<script>
	export default{
		data(){
			return{

			}
		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
</style>


// WEBPACK FOOTER //
// src/views/documents/guide/apiAccess.vue